import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useLogError } from '@/composables/useLogError'
import { useHttpClient } from '@/composables/useHttpClient'
import { useCubeStore } from '@/stores/useCubeStore'

export const useApiManagerStore = defineStore('apiManager', () => {
  const { logError } = useLogError()
  const { backendApi } = useHttpClient()
  const cubeStore = useCubeStore()

  // --- State ---

  const apiKeys = ref<any[]>([])

  // --- Actions ---

  async function loadApiKeys() {
    try {
      const result = await backendApi.get(`/app/ApiConfig/${cubeStore.name}`)
      apiKeys.value = result.data.data.apiKeys
    } catch (err) {
      logError(`Requesting apiData failed: ${err}`)
    }
  }

  async function saveApiKey({ apiKey, apiKeyDesc }: { apiKey: string; apiKeyDesc: string }) {
    try {
      const result = await backendApi.put(`/app/ApiConfig/Key/${cubeStore.name}`, {
        apiKey,
        description: apiKeyDesc,
        isCustom: true,
      })
      if (!result?.data) {
        throw new Error(`Error saving api key for cube: ${cubeStore.name}`)
      }
      await loadApiKeys()
    } catch (err) {
      logError(`Adding apikey failed: ${err}`)
    }
  }

  async function deleteApiKey(apiKey: string) {
    try {
      const result = await backendApi.delete(`/app/ApiConfig/Key/${cubeStore.name}`, {
        data: { apiKey },
      })
      if (!result?.data) {
        throw new Error(`Error deleting api key for cube: ${cubeStore.name}`)
      }
      await loadApiKeys()
    } catch (err) {
      logError(`Removing apikey failed: ${err}`)
    }
  }

  return {
    // State
    apiKeys,
    // Actions
    loadApiKeys,
    saveApiKey,
    deleteApiKey,
  }
})
